import { INoticeState } from './state';

export const getters = {
  noticeList: (state: INoticeState) => state.noticeList,
  total: (state: INoticeState) => state.total
};
